import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

const RightArrowIcon = () => {
	const theme = useTheme();
	return (
		<Box
			component={'svg'}
			fill='currentColor'
			viewBox='0 0 24 24'
			stroke={theme.palette.background.default}
			width={16}
			height={16}>
			<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M17 8l4 4m0 0l-4 4m4-4H3' />
		</Box>
	);
};

export default RightArrowIcon;
